const $body = document.querySelector('body');
let scrollPosition = 0;

export const SingleProperty = {
    modalTrigger: false,
    toggleFloorplans() {
        $('.see-all-floorplans a').on('click', function () {
            var $toggler = $(this).parent();
            var fp_count = $(this).attr('data-count');

            if ($toggler.hasClass('revealed')) {
                $toggler.removeClass('revealed');
                $(this).text('See All (' + fp_count + ')');
                $toggler.prev().children().slice(6).addClass('hidden');
            } else {
                $toggler.addClass('revealed');
                $(this).text('See Less');
                $toggler.prev().children().removeClass('hidden');
            }
            return false;
        });
    },
    toggleCtaBar() {
        $(window).on('scroll', function () {
            if ($(document).scrollTop() > 100) {
                $('.cta-bar').addClass('is-active');
            } else {
                $('.cta-bar').removeClass('is-active');
            }
        });
    },
    truncateToggle() {
        // On page load, set aria-hidden="true" for all paragraphs except the first one
        // Also set tabindex="-1" for <a> tags inside these paragraphs to prevent keyboard focus
        $('.about_nighborhood__summary p:not(:first-of-type)')
            .attr('aria-hidden', 'true')
            .find('a')
            .attr('tabindex', '-1');

        // Attach a click event listener to elements with the class `truncate-toggle`
        // $('.truncate-toggle').on('click', function () {
        // Select the truncatable content just before the clicked button
        $(document).on('click', '.truncate-toggle', function () {
            var $truncatable = $(this).prev();

            // Select all paragraphs and <a> tags in the truncatable content
            var $paragraphs = $truncatable.find('p:not(:first-of-type)');
            var $links = $paragraphs.find('a');

            // Check if the truncatable content is expanded
            if ($truncatable.hasClass('expanded')) {
                // Collapse the content
                $truncatable.removeClass('expanded');
                // Update the button text to "Read More"
                $(this).text('Read More');

                // Hide content from screen readers and prevent keyboard focus
                $paragraphs.attr('aria-hidden', 'true');
                $links.attr('tabindex', '-1');

                // Smoothly scroll back to the top of the `.about_nighborhood` section
                $('html, body').animate(
                    {
                        scrollTop: $('.about_nighborhood').offset().top,
                    },
                    500
                );
            } else {
                // Expand the content
                $truncatable.addClass('expanded');
                // Update the button text to "Read Less"
                $(this).text('Read Less');

                // Make content accessible to screen readers and keyboard focusable
                $paragraphs.attr('aria-hidden', 'false');
                $links.attr('tabindex', '0');

                // Focus on the first <a> tag in any of the <p> tags
                var $firstLink = $truncatable.find('p a').first();
                if ($firstLink.length) {
                    $firstLink.focus();
                }
            }

            // Prevent the default behavior of the button (if it is inside a form or link)
            return false;
        });
    },
    loadImageSlider() {
        var $slider = $('.property-photo-slider').flickity({
            cellSelector: '.slide',
            pageDots: false,
            wrapAround: true,
            selectedAttraction: 0.1,
            friction: 1,
            prevNextButtons: true,
            lazyLoad: 2,
            resize: true,
        });
    },
    loadVideosSlider() {
        var $slider = $('.property-videos-slider').flickity({
            cellSelector: '.slide',
            pageDots: false,
            wrapAround: true,
            selectedAttraction: 0.1,
            friction: 1,
            prevNextButtons: true,
            lazyLoad: 2,
            resize: true,
        });
        $slider.on('change.flickity', function (event, index) {
            SingleProperty.pauseMedia();
        });
    },
    loadToursSlider() {
        var $slider = $('.property-tours-slider').flickity({
            cellSelector: '.slide',
            pageDots: false,
            wrapAround: true,
            selectedAttraction: 0.1,
            friction: 1,
            prevNextButtons: true,
            lazyLoad: 2,
            resize: true,
        });
        $slider.on('change.flickity', function (event, index) {
            SingleProperty.pauseMedia();
        });
        $slider.on(
            'dragStart',
            () => (document.ontouchmove = (e) => e.preventDefault())
        );
        $slider.on('dragEnd', () => (document.ontouchmove = () => true));
    },
    pauseMedia() {
        $('#modal-property-media video').each(function () {
            $(this).get(0).pause();
        });
        $('#modal-property-media iframe').each(function () {
            var src = $(this).attr('src');
            $(this).attr('src', src);
        });
    },
    openModal() {
        // toggleModal('modal-property-media', true);

        $('body').addClass('hide-overflow');
        scrollPosition = window.pageYOffset;
        $body.style.overflow = 'hidden';
        $body.style.position = 'fixed';
        $body.style.top = `-${scrollPosition}px`;
        $body.style.width = '100%';

        SingleProperty.trapFocus();
        $('.image-slider__slider').flickity('resize');
        SingleProperty.modalTrigger.focus();
        $('.close-btn').focus();
    },
    closeModal() {
        // toggleModal('modal-property-media', false);

        $('body').removeClass('hide-overflow');
        $body.style.removeProperty('overflow');
        $body.style.removeProperty('position');
        $body.style.removeProperty('top');
        $body.style.removeProperty('width');
        window.scrollTo(0, scrollPosition);

        SingleProperty.pauseMedia();
        SingleProperty.modalTrigger.focus();
    },
    modalPropertyPhotos() {
        $('[data-property-photos]').on('click', function () {
            SingleProperty.modalTrigger = $(this);
            SingleProperty.openModal();
            return false;
        });

        $('.close-btn').on('click', function () {
            SingleProperty.closeModal();
            return false;
        });

        $('[data-tabs-button]').on('click', function () {
            $('.image-slider__slider').flickity('resize');
            $('.property-tours-slider').flickity('resize');
            $('.property-videos-slider').flickity('resize');
            SingleProperty.pauseMedia();
        });

        $(document).keyup(function (e) {
            if (e.key === 'Escape') {
                if (
                    $('#modal-property-media').length > 0 &&
                    $('#modal-property-media').is(':visible')
                ) {
                    SingleProperty.closeModal();
                }
            }
        });
    },
    getFocusable() {
        var $modal = $('#modal-property-media');
        var $focusable = $(
            'a:visible, button:visible, textarea:visible, input[type="text"]:visible, input[type="radio"]:visible, input[type="checkbox"]:visible, select:visible',
            $modal
        );
        return $focusable;
    },
    trapFocus() {
        var $modal = $('#modal-property-media');
        var KEYCODE_TAB = 9;
        $modal.on('keydown', function (e) {
            var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

            if (!isTabPressed) {
                return;
            }

            var $focusable = SingleProperty.getFocusable();
            var firstFocusableEl = $focusable.first()[0];
            var lastFocusableEl = $focusable.last()[0];

            if (e.shiftKey) {
                if (document.activeElement === firstFocusableEl) {
                    /* shift + tab */
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else {
                /* tab */
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        });
    },

    flickitySliderArrows() {
        const myFSlide = document.querySelectorAll('.photos-panel-2 .slide');
        myFSlide.forEach((element, i) => {
            if (i == 0) {
                $('.photos-panel-2').find('.is-control').hide();
            } else if (i > 0) {
                $('.photos-panel-2').find('.is-control').show();
            }
        });
    },
    videoPlayPause() {
        function playPauseAction(videoElement, button) {
            if (videoElement.paused) {
                videoElement.play();
                $(button).removeClass('play').addClass('pause');
            } else {
                videoElement.pause();
                $(button).removeClass('pause').addClass('play');
            }
        }

        $('.btn-play-pause-web, .btn-play-pause-mob').click(function () {
            var videoId = $(this).hasClass('btn-play-pause-web')
                ? '#banner-video-web'
                : '#banner-video-mobile';
            var video = $(videoId).get(0);
            playPauseAction(video, this);
        });
    },
    getLanLong() {
        if ($('.lat-long-address').length) {
            const latLongAddress = $('.lat-long-address'),
                propertyLatitude = latLongAddress.data('latitude'),
                propertyLongitude = latLongAddress.data('longitude');
            let locationEnabled = false;

            document
                .getElementById('lat-long-address-link')
                .addEventListener('click', function (event) {
                    event.preventDefault();

                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(
                            function (position) {
                                locationEnabled = true;
                                const userLatitude = position.coords.latitude;
                                const userLongitude = position.coords.longitude;

                                const startCoords = `${userLatitude},${userLongitude}`;
                                const destinationCoords = `${propertyLatitude},${propertyLongitude}`;

                                SingleProperty.openDirections(
                                    startCoords,
                                    destinationCoords,
                                    locationEnabled
                                );
                            },
                            function (error) {
                                locationEnabled = false;
                                SingleProperty.openDirections(
                                    '',
                                    `${propertyLatitude},${propertyLongitude}`,
                                    locationEnabled
                                );
                                console.log(
                                    'Unable to retrieve your location. Please allow location access.'
                                );
                            }
                        );
                    } else {
                        alert('Geolocation is not supported by your browser.');
                    }
                });
        }
    },
    openDirections(start, end, locationEnabled) {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (locationEnabled) {
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                // Use Apple Maps on iOS devices
                window.location.href = `http://maps.apple.com/?saddr=${encodeURIComponent(
                    start
                )}&daddr=${encodeURIComponent(end)}&dirflg=d`;
            } else if (/Android/.test(userAgent)) {
                // Use Google Maps on Android devices
                window.location.href = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(
                    start
                )}&destination=${encodeURIComponent(end)}&travelmode=driving`;
            } else {
                // Open driving directions in Google Maps in a new tab
                window.open(
                    `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(
                        start
                    )}&destination=${encodeURIComponent(
                        end
                    )}&travelmode=driving`,
                    '_blank'
                );
            }
        } else {
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                // Open Apple Maps with latitude and longitude on iOS devices
                window.location.href = `http://maps.apple.com/?ll=${encodeURIComponent(
                    end
                )}`;
            } else if (/Android/.test(userAgent)) {
                // Open Google Maps with latitude and longitude on Android devices
                window.location.href = `geo:${end}`;
            } else {
                // Fallback to Google Maps in the browser for other devices (like desktops)
                window.open(
                    `https://www.google.com/maps?q=${encodeURIComponent(end)}`,
                    '_blank'
                );
            }
        }
    },

    backToTop() {
        const backToTopButton = $('.wc_backToTop');

        // Initial setup
        backToTopButton.css({
            // 'opacity': 0,
            transform: 'translateY(100px)',
        });

        // Function to handle scroll behavior
        const handleScroll = () => {
            let scroll = window.scrollY || document.documentElement.scrollTop;
            if (scroll >= 500) {
                backToTopButton.css({
                    // 'opacity': 1,
                    transform: 'translateX(0)',
                });
            } else {
                backToTopButton.css({
                    // 'opacity': 0,
                    transform: 'translateY(100px)',
                });
            }
        };

        // Event listeners for scroll, resize, and page load
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);
        window.addEventListener('load', handleScroll);

        // Smooth scroll to top on button click
        $("a[href='#page-content']").click(function () {
            $('html, body').animate({ scrollTop: 0 }, 'slow');
            return false;
        });

        // Trigger the scroll handler on page load
        handleScroll();
    },
    readMore() {
        const containerToApplyReadMore = $('.overview-read-more-container')
        const pTagsCount = containerToApplyReadMore.find('p');

        if (pTagsCount.length > 1) {
            
            // Append Read More button
            containerToApplyReadMore.append(`
                <button class="read-more-btn transition-all text-brand-md-blue text-[16px] leading-6 font-nunito-sans font-extrabold flex items-center after:w-full after:h-[1px] after:absolute after:left-0 after:bottom-0 relative after:bg-brand-md-blue m-auto md:m-0">
                  Read More 
                  <svg class="w-[6px] h-[12px] block ml-[8px] relative transition-all" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path id="Vector" d="M0 12L6 6L0 0V12Z" fill="#006BA1"></path>
                  </svg>
                </button>
              `)
        }
    },
    // custom CTA buttons
    customCTA_Button(){
        const params = new URLSearchParams(window.location.search);
        const floorplanButtons = document.querySelector(".js-floorplan-cta-buttons");

        if (params.get("spaces_tab") === "unit-detail" || params.get("spaces_tab") === "plan-detail") {
            floorplanButtons?.classList.remove("hidden"); // Remove hidden class if condition is met
        }
    },
    init() {
        if ($('.single-windsor_properties').length > 0) {
            // SingleProperty.loadImageSlider();
            // SingleProperty.loadVideosSlider();
            // SingleProperty.loadToursSlider();
            // SingleProperty.toggleCtaBar();
            SingleProperty.toggleFloorplans();
            // SingleProperty.modalPropertyPhotos();
            SingleProperty.truncateToggle();
            SingleProperty.flickitySliderArrows();
            SingleProperty.videoPlayPause();
            SingleProperty.getLanLong();
            SingleProperty.backToTop();
            if($('.overview-read-more-container')) {
                SingleProperty.readMore();
            }        
            SingleProperty.customCTA_Button();
        }
        $('.windsor-properties-contact-us-link').on('click', function () {
            $(".cta-book-tour__contact").trigger("click");
        });
        // Click event for Read More button
        $(document).on('click', '.read-more-btn', function () {
            let container = $(this).closest('.overview-read-more-container');
            container.find('p:hidden').slideDown();
            $(this).remove();
        });
    },
};

// export default SingleProperty();
